import buildQuery from "odata-query";

import axiosDmsInstance from './axiosDmsInstance';
import { fetchOdataAll } from '../../common/odataUtil';
import { ITypeCode } from '../../models/dms/typecode.model';
import { handleApiError } from '../../common/util';

export const getTypecodesByType = async (type: string) => {
  try {
    const url = `/api/system/typeCode/v1/list`;
    const params = {
      '$inlinecount': 'allpages',
    };

    let filter = {
      and: []
    } as { and: any[]; };

    let orderBy = ['SequenceNumber'];

    filter.and.push({ Type: { eq: type } });

    const query = buildQuery({ filter: filter, orderBy: orderBy });
    const response = await fetchOdataAll<ITypeCode>(axiosDmsInstance, `${url}/${query}`, params);

    return response.data;
  } catch (err: any) {
    return handleApiError('getTypecodesByType', err);
  }
};